import * as React from 'react';
import { observer } from 'mobx-react';
import LicenseStatus from './LicenseStatus';
import LearningCollectionStore from '../../../../Store';
import MoreDetailsMobileView from './MoreDetailsMobileView';
import { ProductLicenseResource } from '../../../../../Types';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { productLicenseCardStyle } from './Selection';
import { AlreadyTranslated } from '../../../../../../../Translations';
import clsx from 'clsx';
import { assertNever, noop } from '@kofno/piper';
import LicenseAction from './LicenseAction';

interface Props {
  store: LearningCollectionStore;
  activeProductLicense: ProductLicenseResource;
  dataIntercomTarget?: string;
}

const ActiveProductLicense: React.FC<Props> = ({
  store,
  activeProductLicense,
  dataIntercomTarget,
}) => {
  const radioId = `product-license-${activeProductLicense.payload.id}`;

  const handleSelect = () => {
    switch (activeProductLicense.payload.productType) {
      case 'Core':
        store.selectProductLicense(activeProductLicense.payload.id);
        break;
      case 'Add-on':
        noop;
        break;
      default:
        assertNever(activeProductLicense.payload.productType);
    }
  };

  return (
    <div
      key={activeProductLicense.payload.id}
      className={clsx(productLicenseCardStyle(store.selectedProductLicense, activeProductLicense))}
      onClick={handleSelect}
      data-intercom-target={dataIntercomTarget}
    >
      <div className="flex">
        <LicenseAction
          activeProductLicense={activeProductLicense}
          store={store}
          radioId={radioId}
        />
        <label htmlFor={radioId} className="font-medium">
          {activeProductLicense.payload.licenseTypePublicName
            .map((licenseTypePublicName) => <AlreadyTranslated content={licenseTypePublicName} />)
            .getOrElse(emptyFragment)}
        </label>
      </div>
      <LicenseStatus activeProductLicense={activeProductLicense} />
      <p className="my-1 text-sm">
        {activeProductLicense.payload.licenseTypePublicDescription
          .map((licenseTypePublicDescription) => (
            <AlreadyTranslated content={licenseTypePublicDescription} />
          ))
          .getOrElse(emptyFragment)}
      </p>
      <MoreDetailsMobileView store={store} activeProductLicense={activeProductLicense} />
    </div>
  );
};

export default observer(ActiveProductLicense);
